import { IEntityId } from '../IEntityId';
import { VersionGame } from './VersionGame';

export interface Terrain extends IEntityId<number> {
  size: string;
  logo: string | null;
  width: number;
  height: number;
}

export enum MapElementOrientation {
  HORIZONTAL = 'Horizontal',
  VERTICAL = 'Vertical',
  DIAGONAL_TOP = 'DiagonalTop',
  DIAGONAL_BOTTOM = 'DiagonalBottom',
}

export interface MapElement {
  orientation: MapElementOrientation;

  top?: number;
  left?: number;
  right?: number;
  bottom?: number;

  terrain: Terrain;
}

export interface Map extends IEntityId<number> {
  initials: string;
  description: string;
  game: VersionGame;
  logo: string | null;
  elements: MapElement[];
}
